import { ANNOUNCEMENTS_ACTION_TYPE } from "../../actions/utilities";

const initialState = {
    getAll: [],
    getAllLoading: false,

    getById: null,
    getBYIdLoading: false,

    addLoading: false,

    removeLoading: false,

    editLoading: false
};

const announcementReducer = (state = initialState, action) => {
    switch (action.type) {
        case ANNOUNCEMENTS_ACTION_TYPE.CREATE_REQUEST:
            return {
                ...state,
                addLoading: true
            }
        case ANNOUNCEMENTS_ACTION_TYPE.CREATE_FAILURE:
        case ANNOUNCEMENTS_ACTION_TYPE.CREATE_SUCCESS:
            return {
                ...state,
                addLoading: false
            }

        case ANNOUNCEMENTS_ACTION_TYPE.UPDATE_REQUEST:
            return {
                ...state,
                editLoading: true
            }
        case ANNOUNCEMENTS_ACTION_TYPE.UPDATE_FAILURE:
            return {
                ...state,
                editLoading: false
            }
        case ANNOUNCEMENTS_ACTION_TYPE.UPDATE_SUCCESS:
            return {
                ...state,
                editLoading: false,
                getAll: {
                    ...state.getAll,
                    announcements: state.getAll.announcements.map((announcement) =>
                        announcement.id === action.payload.id
                            ? { ...announcement, ...action.payload } // ✅ update with new data
                            : announcement
                    ),
                },
            };
        case ANNOUNCEMENTS_ACTION_TYPE.GET_REQUEST:
            return {
                ...state,
                getAllLoading: true
            }
        case ANNOUNCEMENTS_ACTION_TYPE.GET_FAILURE:
            return {
                ...state,
                getAllLoading: false
            }
        case ANNOUNCEMENTS_ACTION_TYPE.GET_SUCCESS:
            return {
                ...state,
                getAllLoading: false,
                getAll: action.payload
            }
        case ANNOUNCEMENTS_ACTION_TYPE.GET_BY_ID_REQUEST:
            return {
                ...state,
                getBYIdLoading: true
            }
        case ANNOUNCEMENTS_ACTION_TYPE.GET_BY_ID_FAILURE:
            return {
                ...state,
                getBYIdLoading: false
            }
        case ANNOUNCEMENTS_ACTION_TYPE.GET_BY_ID_SUCCESS:
            return {
                ...state,
                getBYIdLoading: false,
                getById: action.payload
            }
        case ANNOUNCEMENTS_ACTION_TYPE.REMOVE_REQUEST:
            return {
                ...state,
                removeLoading: true
            }
        case ANNOUNCEMENTS_ACTION_TYPE.REMOVE_FAILURE:
            return {
                ...state,
                removeLoading: false
            }
        case ANNOUNCEMENTS_ACTION_TYPE.REMOVE_SUCCESS:
            return {
                ...state,
                removeLoading: false,
                getAll: {
                    ...state.getAll,
                    announcements: state.getAll.announcements.filter(
                        (announcement) => announcement.id !== action.payload
                    ),
                },
            }
        default:
            return state;
    }
};

export default announcementReducer;
